/// <amd-module name="VSSUI/Components/IdentityPickerSuggestionsList/IdentityPickerSuggestionsList" />
import * as React from "react";
import { Callout } from "VSSUI/Callout";
import { IdentityCard } from "VSSUI/IdentityCard";
import { Observer } from "VSSUI/Observer";
import * as Resources from "VSSUI/Resources.IdentityPicker";
import { SuggestionsList } from "VSSUI/SuggestionsList";
import { css } from "VSSUI/Util";
import { IIdentity } from "../IdentityPickerDropdown/SharedIdentityPicker.Props";
import { IdentityPickerSuggestionsListProps } from "./IdentityPickerSuggestionsList.Props";

export class IdentityPickerSuggestionsList extends React.Component<IdentityPickerSuggestionsListProps> {
    public render(): JSX.Element {
        return (
            <>
                <Observer
                    suggestionsVisible={this.props.suggestionsVisible}
                    suggestionsLoading={this.props.isLoading}
                    selectedIndex={this.props.selectedIndex}
                    suggestions={this.props.suggestions}
                >
                    {(props: { suggestionsVisible: boolean; suggestionsLoading: boolean; selectedIndex: number; suggestions: IIdentity[] }) => {
                        return props.suggestionsVisible ? (
                            <Callout
                                {...this.props.calloutProps}
                                className={css("bolt-identitypickerdropdown-callout", this.props.calloutProps.className)}
                                contentClassName={css(
                                    "bolt-identitypickerdropdown-callout-content flex-row flex-grow",
                                    this.props.calloutProps.contentClassName
                                )}
                            >
                                <SuggestionsList
                                    {...this.props}
                                    className={css("bolt-identitypickerdropdown-list", this.props.className)}
                                    isLoading={props.suggestionsLoading}
                                    loadingText={this.props.loadingText || Resources.IdentityPickerLoadingText}
                                    renderNoResultFound={this.renderNoIdentitiesFound}
                                    renderSuggestion={this.props.renderSuggestion}
                                    onBlur={this.props.onBlur}
                                    onFocus={this.props.onFocus}
                                    resultsMaximumNumber={25}
                                    suggestionsItemClassName={css("bolt-identitypickerdropdown-item", this.props.suggestionsItemClassName)}
                                    suggestions={props.suggestions}
                                    selectedIndex={props.selectedIndex}
                                    width={this.props.width}
                                />
                            </Callout>
                        ) : (
                            <div />
                        );
                    }}
                </Observer>
                <Observer openedIdentityCard={this.props.openedIdentityCard}>
                    {(props: { openedIdentityCard: IIdentity }) => {
                        return props.openedIdentityCard ? (
                            <IdentityCard
                                getEntityFromUniqueAttribute={this.props.pickerProvider.getEntityFromUniqueAttribute}
                                key={props.openedIdentityCard.entityId}
                                identity={props.openedIdentityCard}
                                target={this.props.suggestionTarget}
                                onDismissCallback={this.props.onClosePersonaCard}
                                onRequestConnectionInformation={this.props.pickerProvider.onRequestConnectionInformation}
                            />
                        ) : (
                            <div />
                        );
                    }}
                </Observer>
            </>
        );
    }

    private renderNoIdentitiesFound = (): JSX.Element => {
        return (
            <div className="bolt-identitypickerdropdown-noresults flex-row flex-grow flex-center">
                {this.props.noResultsFoundText || Resources.IdentityPickerNoResultsText}
            </div>
        );
    };
}
